import {
    ADDITIONAL_PHONE_OWNER_SOURCE, CAR_SOURCE,
    EDUCATION_SOURCE,
    FAMILY_STATUS_SOURCE,
    NUMBER_OF_DEPENDENTS_SOURCE, PROPERTY_TYPE_SOURCE,
} from '../../constants/sources';

export const educationOptions = EDUCATION_SOURCE.map(({ name: label, value }) => ({ label, value }));
export const familyStatusOptions = FAMILY_STATUS_SOURCE.map(({ name: label, value }) => ({ label, value }));
export const dependentsOptions = NUMBER_OF_DEPENDENTS_SOURCE.map(({ name: label, value }) => ({ label, value }));
export const additionalPhoneOwnerOptions = ADDITIONAL_PHONE_OWNER_SOURCE.map(({ name: label, value }) => ({
    label,
    value,
}));
export const propertyTypeOptions = PROPERTY_TYPE_SOURCE.map(({ name: label, value }) => ({ label, value }));
export const carTypeOptions = CAR_SOURCE.map(({ name: label, value }) => ({ label, value }));
